import Flex from 'components/priority/Flex/Flex'
import Text from 'components/priority/Text/Text'
import { ToggleSwitch } from 'components/global/ToggleSwitch/ToggleSwitch'
import { useRecoilState } from 'recoil'
import { itemSelector } from 'atoms'
import { useIsAdmin } from '@/hooks/utility/useIsAdmin'
import { useTranslation } from 'react-i18next'

export const MaintainAspectRatio = ({ selectedItem }) => {
  const { t } = useTranslation()
  const isAdmin = useIsAdmin()
  const [maintainAspectRatio, setMaintainAspectRatio] = useRecoilState(
    itemSelector({ id: selectedItem, path: 'maintainAspectRatio' }),
  )

  if (!isAdmin) {
    return null
  }

  return (
    <>
      <Text margin="0 0 16px">
        {t('editor.menus.properties.elements.maintainAspectRatioButton')}
      </Text>
      <Flex margin="0 0 24px">
        <ToggleSwitch value={[maintainAspectRatio, setMaintainAspectRatio]} />
      </Flex>
    </>
  )
}
